import React from 'react';

export default function FooterCopyright() {
  return (
    <div className="footerContainer footerContainer--mod">
      <div>
        Enterprise Ecosystem Infrastructure for organisations becoming Ecosystem Operators.
      </div>

      <div>
        © 2026 GBR Farming Private Limited. All rights reserved.
      </div>
    </div>
  )
}